module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wrongFlag),
      expression: "wrongFlag"
    }],
    staticClass: "dialog-demo",
    model: {
      value: (_vm.showLog),
      callback: function($$v) {
        _vm.showLog = $$v
      },
      expression: "showLog"
    }
  }, [_c('div', {
    staticClass: "res-box"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("好遗憾，答错了")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("复活后才可继续答题哦~每日限一次")]), _vm._v(" "), _c('div', {
    staticClass: "mid-box"
  }, [_c('img', {
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E5%A4%8D%E6%B4%BB%E5%8D%A1@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("X")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.reviveNum > 99 ? '99+' : _vm.reviveNum))])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-box"
  }, [_c('x-button', {
    staticClass: "cannel currency",
    nativeOn: {
      "click": function($event) {
        return _vm.cannel.apply(null, arguments)
      }
    }
  }, [_vm._v("算了")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-box"
  }, [_c('x-button', {
    staticClass: "confirm currency",
    nativeOn: {
      "click": function($event) {
        return _vm.confirm.apply(null, arguments)
      }
    }
  }, [_vm._v("复活 ")])], 1)], 1)])]), _vm._v(" "), _c('x-dialog', {
    staticClass: "app-box",
    model: {
      value: (_vm.appFlag),
      callback: function($$v) {
        _vm.appFlag = $$v
      },
      expression: "appFlag"
    }
  }, [_c('div', {
    staticClass: "res-box"
  }, [_c('span', {
    staticStyle: {
      "font-size": ".6rem"
    },
    on: {
      "click": _vm.cannel
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/img/luotai/u8.png"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n              您的复活卡用完了，请打开医生汇APP积分商城兑换复活卡。\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "1rem",
      "padding": "0 .5rem",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "canBtn",
    on: {
      "click": _vm.cannel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "openBtn",
    on: {
      "click": _vm.openApp
    }
  }, [_vm._v("打开APP")])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-a9af0e5c"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Resurrection.vue
// module id = 243
// module chunks = 1